import React from "react";
import { Link } from "react-router-dom";
import AllPostSlider from "./AllPostSlider";
import { AdminMainText, AdminMetric } from "../../AdminDashboard/shared/adminUx";

const TABS = [
  { id: "all", label: "All post", count: 23, active: true },
  { id: "saved", label: "Saved", count: 5, active: false },
  { id: "shared", label: "Shared", count: 8, active: false },
  { id: "viewed", label: "Viewed", count: 10, active: false },
];

const AllPost = () => {
  return (
    <>
      <div className="w-[700px] lg:w-[992px] mx-auto hidden md:block mb-20">
        <div className="border-b-2 border-lightgray max-w-fit">
          <ul className="flex flex-wrap -mb-px text-center">
            {TABS.map((tab) => (
              <li key={tab.id}>
                <Link
                  to="#"
                  className={`flex items-center justify-center gap-2 pb-2 h-5 pr-20 border-b-2 rounded-t-lg group ${
                    tab.active
                      ? "border-b-primaryblue text-primaryblue"
                      : "border-transparent text-mediumgray hover:text-primaryblue hover:border-primaryblue"
                  }`}
                >
                  <AdminMainText
                    className={
                      tab.active
                        ? "text-primaryblue"
                        : "text-mediumgray group-hover:text-primaryblue"
                    }
                  >
                    {tab.label}
                  </AdminMainText>
                  <AdminMetric size="small" className="text-inherit tabular-nums">
                    {tab.count}
                  </AdminMetric>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <AllPostSlider />
    </>
  );
};

export default AllPost;
